var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-steps"},[_vm._t("default",null,{"active":_vm.active})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }